module.exports = __webpack_public_path__ + "static/media/likes.cf8108b7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slides/LastProjects/components/BehancePreview/assets/likes.svg
// module id = 47
// module chunks = 0